module.exports = __webpack_public_path__ + "img/Group_26986.88a7de79.svg";